<template>
  <div id="app-prices">
    <UrlParams v-model="urlParams" />
    <Tabs v-model="urlParams.tab">
      <Tab key="tab-overview" title="Overview" lazy>
        <OverviewStatic />
      </Tab>
      <Tab key="tab-yearly-prices" title="Yearly prices" lazy>
        <YearlyPrices v-model="country" :url="url" />
      </Tab>
      <Tab key="tab-monthly-prices" title="Monthly prices" lazy>
        <MonthlyPrices v-model="country" :test="test" />
      </Tab>
      <Tab key="tab-expenditure-indicators" title="Expenditure indicators" lazy>
        <ExpenditureIndicators v-model="country" :test="test" />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import { Tabs, Tab, UrlParams } from "@international-energy-agency/vue-ui";
// import { Tabs, Tab, UrlParams } from "../../vue-ui/src/main";

import OverviewStatic from "./OverviewStatic.vue";
import YearlyPrices from "./YearlyPrices.vue";
import MonthlyPrices from "./MonthlyPrices.vue";
import ExpenditureIndicators from "./ExpenditureIndicators.vue";

const regions = [
  'Africa',
  'Asia',
  'Americas',
  'EU27',
  'Europe',
  'G20',
  'OECD',
  'Oceania',
  'World'
]

export default {
  name: "App",
  components: {
    Tabs,
    Tab,
    UrlParams,
    OverviewStatic,
    YearlyPrices,
    MonthlyPrices,
    ExpenditureIndicators,
  },
  props: {
    test: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      country: "World",
      urlParams: {
        tab: "Overview",
      },
    };
  },
  computed: {
    url() {
      return `https://api.${this.test ? "test." : ""}iea.org/prices`;
    },
  },
};
</script>
<style>
#app-prices .m-chart-block .m-chart--params {
  flex-wrap: nowrap !important;
}
#app-prices .m-chart-block.container + .container {
  margin-top: 60px;
}
</style>